import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import SingleUser from '../../components/Users/SingleUser';
import { getSingleUser, updatePassword } from '../../store/actions/users/users.action';
import PageLoader from '../../components/Common/PageLoader';
import '../../styles/users.css';

const SingleUserContainer = () => {
  // Router hooks
  const params = useParams();
  const dispatch = useDispatch();

  // Redux state
  const isFetching = useSelector((state) => state.users.isFetching);
  const singleUser = useSelector((state) => state.users.singleUser);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      if (!categories || !Array.isArray(categories)) {
        setAccessDenied(true);
        return;
      }

      const userCategory = categories.find(category => category.link === 'users');

      if (userCategory && userCategory.mode) {
        setMode(userCategory.mode);
        setAccessDenied(false);
      } else {
        setAccessDenied(true);
      }
    } catch (err) {
      console.error('Error setting access:', err);
      setAccessDenied(true);
    }
  }, [categories]);

  // Handle password update
  const handleUpdatePassword = useCallback((userId, passwordData) => {
    return dispatch(updatePassword(userId, passwordData));
  }, [dispatch]);

  // Fetch user on mount if ID exists
  useEffect(() => {
    const { id } = params || {};

    if (id) {
      dispatch(getSingleUser(id));
    }

    setAccess();
  }, [params, dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return (
      <div className="access-denied">
        This category is not accessible to the logged in user.
      </div>
    );
  }

  // User not found state
  if (!singleUser) {
    return (
      <div className="no-user">
        User not found.
      </div>
    );
  }

  return (
    <section id="user">
      <SingleUser
        mode={mode}
        user={singleUser}
        updatePassword={handleUpdatePassword}
      />
    </section>
  );
};

export default SingleUserContainer;
